export default "__VITE_ASSET__15e27149__"